import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControlOptions, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonDirective } from 'primeng/button';
import { Ripple } from 'primeng/ripple';
import { DropdownModule } from "primeng/dropdown";
import { InputSwitchModule } from "primeng/inputswitch";
import { PasswordModule } from "primeng/password";
import { FormComponent } from "@app/modules/shared/components/form/form.component";
import { PageComponent } from "@app/modules/shared/components/page/page.component";
import { SystemUserService } from "@app/modules/admin/system-user/system-user.service";
import { ResetPassword } from "@app/modules/admin/model/system-user.model";
import { GenericResponse } from "@app/core/backend";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { APP_ROUTES } from "@app/constants";
import { UtilService } from "@app/modules/shared/service/util.service";
import { FieldValidatorService, PasswordRule } from "@app/modules/shared/service/field-validator.service";

@Component({
    selector: 'app-change-password',
    standalone: true,
    imports: [
        CommonModule,
        FormComponent,
        ReactiveFormsModule,
        PageComponent,
        InputTextModule,
        ButtonDirective,
        Ripple,
        DropdownModule,
        InputSwitchModule,
        PasswordModule
    ],
    templateUrl: './change-password.component.html',
    styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent {
    id!: string;
    title!: string | null;
    buttonTitle!: string | null;
    disableField: boolean = false;
    changePasswordForm!: FormGroup;
    submitButtonPressed = false;
    user!: string;

    passwordRules: PasswordRule[] = [];

    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly messageService: MessageService,
        private readonly userService: SystemUserService,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        public readonly dialogRef: DynamicDialogRef,
        public readonly dialogConfig: DynamicDialogConfig,
        private readonly utilService: UtilService,
        private readonly fieldValidatorService: FieldValidatorService,
    ) {
        this.user = dialogConfig.data;
        this.passwordRules = this.fieldValidatorService.getPasswordRules();
    }

    ngOnInit() {
        this.changePasswordForm = this.formBuilder.group({
    oldPassword: ['', Validators.required],
    newPassword: ['', [Validators.required, this.passwordStrengthValidator.bind(this)]],
    confirmPassword: [''],
}, {
    validators: [
        this.fieldValidatorService.passwordMatchValidator,
        this.fieldValidatorService.oldAndNewPasswordSameValidator
    ]
} as FormControlOptions);

       this.changePasswordForm.get('newPassword')?.valueChanges.subscribe((value) => {
    this.fieldValidatorService.checkPasswordStrength(value, this.passwordRules);
    // this.updatePasswordDifferenceRule();
    // this.changePasswordForm.updateValueAndValidity({ emitEvent: false });
    this.changePasswordForm.get('confirmPassword')?.updateValueAndValidity({ onlySelf: true });
});

this.changePasswordForm.get('oldPassword')?.valueChanges.subscribe(() => {
    // this.updatePasswordDifferenceRule();
    this.changePasswordForm.updateValueAndValidity({ emitEvent: false });
});
    }

    passwordStrengthValidator(control: any): { [key: string]: boolean } | null {
        const value = control.value || '';
        this.fieldValidatorService.checkPasswordStrength(value, this.passwordRules);
        const allValid = this.passwordRules.every(rule => rule.valid);
        return allValid ? null : { 'passwordStrength': true };
    }
    // private updatePasswordDifferenceRule(): void {
    //     const oldPassword = this.changePasswordForm.get('oldPassword')?.value || '';
    //     const newPassword = this.changePasswordForm.get('newPassword')?.value || '';

    //     const rule = this.passwordRules.find(
    //         r => r.label === 'New password must be different from current password'
    //     );

    //     if (rule) {
    //         rule.valid = !!newPassword && oldPassword !== newPassword;
    //     }
    // }
    setUserRequest(form: FormGroup) {
        return new ResetPassword(null, form.value.newPassword, form.value.confirmPassword, form.value.oldPassword);
    }

    resetPassword() {
        this.utilService.validateForm(this.changePasswordForm);
        if (this.changePasswordForm.invalid) {
            return;
        }

        const userData = this.setUserRequest(this.changePasswordForm);
        this.submitButtonPressed = true;
        this.userService.changePassword(userData).subscribe({
            next: response => {
                this.submitButtonPressed = false;
                this.messageService.add({
                    key: 'message',
                    severity: 'success',
                    summary: 'Success',
                    detail: response.message
                });
                this.sendMessage();
            },
            error: errorResponse => {
                let errorData: GenericResponse<any> = errorResponse.error;
                this.submitButtonPressed = false;
                if (errorResponse && errorData?.message) {
                    this.messageService.add({
                        key: 'message',
                        severity: 'error',
                        summary: 'Error',
                        detail: errorData.message
                    });
                } else {
                    this.messageService.add({
                        key: 'message',
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to reset Password'
                    });
                }
            }
        });
    }


    getErrorMessage(title: string): string {
        return this.utilService.getErrorMessage(title, this.changePasswordForm);
    }

    showError(formControlName: string) {
        return this.utilService.showError(formControlName, this.changePasswordForm);
    }

    goBack() {
        this.dialogRef.close();
    }

    sendMessage() {
        const message = 'success';
        this.dialogRef.close(message);
        this.router.navigate([APP_ROUTES.LOGOUT]).then();
    }
}
